import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SidebarComponent } from './components/sidebar/sidebar.component'
import { TopbarComponent } from './components/topbar/topbar.component'
import { BottombarComponent } from './components/bottombar/bottombar.component'
import { FormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { AuthGuardService } from './services/auth-guard.service'
import { AuthUserHelper } from './helpers/auth-user.helper'
import { ApiEnvironment } from './helpers/api-environment.helper'
import { AuthenticationService } from './services/authentication.service'
import { AgentService } from './services/agent.service'
import { TransactionService } from './services/transaction.service'
import { TransferCommissionService } from './services/transferCommission.service'
// import {ExcelService} from './services/excel.service';
import { GraphService } from './services/graph.service'
import { BankService } from './services/bank.service'
import { UiSwitchModule } from 'ngx-ui-switch'
import { DatePickerModule } from './directives/date-picker.module'
import { AdminService } from './services/admin.service'
import { FirstwordPipe } from './components/topbar/firstword.pipe'
import { DraggableDirective } from './directives/draggable.directive'

// C:\Users\lawal\icash-angular-admin\node_modules\ngx-toggle-switch

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        UiSwitchModule,
        DatePickerModule,
        SidebarComponent,
        TopbarComponent,
        BottombarComponent,
        FirstwordPipe,
        DraggableDirective
    ],
    exports: [
        CommonModule,
        RouterModule,
        FormsModule,
        UiSwitchModule,
        DatePickerModule,
        SidebarComponent,
        TopbarComponent,
        BottombarComponent,
        DraggableDirective
    ],
    providers: [
        AuthUserHelper,
        ApiEnvironment,
        AuthGuardService,
        AuthenticationService,
        AgentService,
        TransactionService,
        GraphService,
        BankService,
        AdminService,
        TransferCommissionService
    ]
})
export class SharedModule {}
